import { createRouter, createWebHistory } from '@ionic/vue-router'
import store from '../store'

const routes = [
  { path: '/', component: () => import('../views/Home.vue') },
  { path: '/home', redirect: '/' },
  { path: '/login', component: () => import('../views/Login.vue') },
  { path: '/admin/login', component: () => import('../views/Login.vue') },
  { path: '/dashboard', component: () => import('../views/Dashboard.vue'), meta: { requiresAuth: true } },
  { path: '/admin/dashboard', redirect: '/admin/panel', meta: { role: 'admin' } },
  { path: '/staff/dashboard', redirect: '/staff/panel', meta: { role: 'staff' } },
  { path: '/admin/gallery', redirect: '/admin/panel/gallery' },
  {
    path: '/admin/panel',
    component: () => import('../views/admin/AdminPanel.vue'),
    meta: { requiresAuth: true, role: 'admin' },
    children: [
      { path: '', component: () => import('../views/admin/AdminPanelHome.vue'), meta: { requiresAuth: true, role: 'admin' } },
      { path: 'staff', component: () => import('../views/admin/AdminStaff.vue'), meta: { requiresAuth: true, role: 'admin' } },
      { path: 'sales', component: () => import('../views/admin/AdminSales.vue'), meta: { requiresAuth: true, role: 'admin' } },
      { path: 'purchases', component: () => import('../views/admin/AdminPurchases.vue'), meta: { requiresAuth: true, role: 'admin' } },
      { path: 'available', component: () => import('../views/admin/AdminAvailableVehicles.vue'), meta: { requiresAuth: true, role: 'admin' } },
      { path: 'gallery', component: () => import('../views/admin/AdminGallery.vue'), meta: { requiresAuth: true, role: 'admin' } },
      { path: 'branches', component: () => import('../views/admin/AdminBranches.vue'), meta: { requiresAuth: true, role: 'admin' } },
      { path: 'header', component: () => import('../views/admin/AdminHeader.vue'), meta: { requiresAuth: true, role: 'admin' } },
      { path: 'hero', component: () => import('../views/admin/AdminHero.vue'), meta: { requiresAuth: true, role: 'admin' } },
      { path: 'products', component: () => import('../views/admin/AdminProducts.vue'), meta: { requiresAuth: true, role: 'admin' } },
      { path: 'testimonials', component: () => import('../views/admin/AdminTestimonials.vue'), meta: { requiresAuth: true, role: 'admin' } },
      { path: 'agreements', component: () => import('../views/admin/AdminAgreements.vue'), meta: { requiresAuth: true, role: 'admin' } },
      { path: 'expenses', component: () => import('../views/admin/AdminExpenses.vue'), meta: { requiresAuth: true, role: 'admin' } },
      { path: 'account-sheet', component: () => import('../views/admin/AdminAccountSheet.vue'), meta: { requiresAuth: true, role: 'admin' } },
      { path: 'accountants', component: () => import('../views/admin/AdminAccountants.vue'), meta: { requiresAuth: true, role: 'admin' } },
      { path: 'contact-messages', component: () => import('../views/admin/AdminContactMessages.vue'), meta: { requiresAuth: true, role: 'admin' } }
    ]
  },
  {
    path: '/staff/panel',
    component: () => import('../views/staff/StaffPanel.vue'),
    meta: { requiresAuth: true, role: 'staff' },
    children: [
      { path: '', component: () => import('../views/staff/StaffPanelHome.vue'), meta: { requiresAuth: true, role: 'staff' } },
      { path: 'sales', component: () => import('../views/staff/StaffSales.vue'), meta: { requiresAuth: true, role: 'staff' } },
      { path: 'purchases', component: () => import('../views/staff/StaffPurchases.vue'), meta: { requiresAuth: true, role: 'staff' } },
      { path: 'available', component: () => import('../views/staff/StaffAvailableVehicles.vue'), meta: { requiresAuth: true, role: 'staff' } },
      { path: 'agreements', component: () => import('../views/staff/StaffAgreements.vue'), meta: { requiresAuth: true, role: 'staff' } },
      { path: 'expenses', component: () => import('../views/admin/AdminExpenses.vue'), meta: { requiresAuth: true, role: 'staff' } }
    ]
  },
  { path: '/agreements', component: () => import('../views/AgreementList.vue') },
  // direct create pages only (no separate list pages yet)
  { path: '/agreements/create/sale', component: () => import('../views/CreateSaleAgreement.vue'), meta: { requiresAuth: true } },
  { path: '/agreements/create/purchase', component: () => import('../views/CreatePurchaseAgreement.vue'), meta: { requiresAuth: true } },
  {
    path: '/sales/invoice',
    component: () => import('../views/SaleInvoice.vue'),
    meta: { requiresAuth: true, hideGlobalChrome: true }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

// Global auth/role guard
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(r => r.meta && r.meta.requiresAuth)
  const loggedIn = store.getters['auth/isLoggedIn']
  if (requiresAuth && !loggedIn) {
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }
  const requiredRole = to.matched.find(r => r.meta && r.meta.role)?.meta?.role
  const role = store.getters['auth/getRole']
  if (requiredRole && role !== requiredRole) {
    return next({ path: '/dashboard' })
  }
  next()
})

export default router
